import {type UIGameManager} from '../UIGameManager.ts'
import {type UIGameMechanic} from '../UIGameEventController.ts'
import {GameStateEnums} from '../../../../../shared/GameEnums.ts'
import {UIGameMapCornerView} from './UIGameMapCornerView.ts'
import {Sprites} from '../UIGameImageDictionary.ts'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler.ts'
import {TileCornerBonusType} from '@colonist/game-states'
import {Point, type TileCorner} from '@colonist/game-mechanic-validators'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {ArrayUtils} from '@colonist/utils'

export class UIGameMapChitController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly chitViews: UIGameMapCornerView[] = []

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        const animate = false
        this.drawChits(animate)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MapStateUpdated: this.drawChits(); break
            default: break
        }
    }

    private drawChits(animate: boolean = true) {
        for(const corner of this.uiGameManager.gameController.mapValidator.tileState.tileCorners) {
            if(corner.buildingType === undefined) {
                this.destroyChitView(corner)
                continue
            }
            if(!corner.hasCornerBonusOfType(TileCornerBonusType.IslandSettlingChits)) continue
            if(this.getExistingChitViewForCorner(corner)) continue

            this.drawChitOnCorner(corner, animate)
        }
    }

    private destroyChitView(corner: TileCorner) {
        const chitView = this.getExistingChitViewForCorner(corner)
        if(chitView === undefined) return

        chitView.destroy()
        ArrayUtils.removeElementFromArray(this.chitViews, chitView)
    }

    private getExistingChitViewForCorner(corner: TileCorner): UIGameMapCornerView | undefined {
        for(const oldCornerView of this.chitViews) {
            if(oldCornerView.corner.sameCorner(corner)) return oldCornerView
        }
        return undefined
    }

    private drawChitOnCorner(corner: TileCorner, animate: boolean = true) {
        const center = corner.hexCorner.toPixel(this.uiGameManager.mapController.mapView.mapCenter, this.uiGameManager.mapController.mapView.hexagonHeight / 2)

        const x = center.x + this.uiGameManager.mapController.mapView.cornerCircleR * 0.15
        const y = center.y - this.uiGameManager.mapController.mapView.cornerCircleR * 1.1
        const animationStartY = animate ? y - this.uiGameManager.mapController.mapView.hexagonHeight : y

        const w = this.uiGameManager.mapController.mapView.cornerCircleR
        const h = w

        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_chit)
        const chitView = new UIGameMapCornerView(corner, x, animationStartY, w, h, this.uiGameManager.mapController.mapView.layers.chits, texture, this.uiGameManager.mapController.mapView)
        const topRightCornerOfCornerBuilding = new Point(x, y)
        chitView.animationController.animateTo(topRightCornerOfCornerBuilding)
        this.chitViews.push(chitView)
    }
}
